<!-- Broadcast -->
<button
    mat-icon-button
    (click)="openBroadcastDrawer()"
    aria-label="Broadcast">
    <ng-container *ngIf="broadcastCount > 0">
        <span class="absolute top-0 right-0 left-0 flex items-center justify-center h-3 z-10">
            <span class="flex items-center justify-center flex-shrink-0 min-w-4 h-4 px-1 ml-4 mt-2.5 rounded-full bg-primary-600 text-primary-50 text-xs font-medium leading-extra-loose">
                {{broadcastCount}}
            </span>
        </span>
    </ng-container>
    <mat-icon [svgIcon]="'heroicons_outline:megaphone'"></mat-icon>     
</button>